export { default } from './Flag'
